import { connect } from 'react-redux'

import ShopifyIndexView from './view'

export default connect(null, {})(ShopifyIndexView)
